import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom'
import Question from '../components/question/Question';
import FormTitle from '../title/FormTitle';
import { formValidation, relatedQuestionsValidation, resetRelatedQuestionsValidation, resetValidation } from '../functions/Validation';
import BackToTop from '../components/backToTop/BackToTop';
import { AnswerType } from '../enums/AnswerType';
/*import TagManager from 'react-gtm-module';*/
import { enableQuestion, enableQuestionsInSet, showConditionalChildrenChildren, showConditionalChildrenQuestions, showConditionalQuestionsInSet } from '../functions/QuestionEnabling';
import { tracking } from '../functions/Tracking';
import { Action } from '../enums/TrackingActionType';
import { IsWebReference } from '../functions/Configuration';

//const tagManagerArgs = {
//    dataLayer: {
//        userId: '001',
//        userProject: 'CAQWeb',
//        page: 'EmployeeDetails'
//    },
//    dataLayerName: 'EmployeeDetailsPageDataLayer'
//}

export default function EmployeeDetails(props: any) {
    const location = useLocation();

    const [questions, setQuestions] = useState<any[]>([]);
    const navigate = useNavigate();
    const [readyToNavigate, setReadyToNavigate] = useState(false);
    const [scrollToError, setScrollToError] = useState(false);
    const [manualDirectorsId, setManualDirectorsId] = useState(0);
    const [nonManualDirectorsId, setNonManualDirectorsId] = useState(0);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const pageNo: number = 2;
    let webReference = localStorage.getItem('webReference') || "";
    let companyStatus = localStorage.getItem('status') || "";

    /*TagManager.dataLayer(tagManagerArgs)*/
    props.setSidebarVisibility(true);

    useEffect(() => {
        props.setCurrentPage(pageNo);

        let storedQuestions = localStorage.getItem('questions');

            if (storedQuestions != null) {
                let questionSet = JSON.parse(storedQuestions);
                setQuestions(questionSet);

                if (IsWebReference("TL") && companyStatus === "limited") {
                    questionSet.forEach((question: any) => {
                        if (question.questionSetQuestion.text.toLowerCase() === "how many directors carry out manual work?") {
                            setManualDirectorsId(question.questionSetQuestion.questionID);
                        }

                        if (question.questionSetQuestion.text.toLowerCase() === "how many directors are there that carry out clerical work only?") {
                            setNonManualDirectorsId(question.questionSetQuestion.questionID);
                        }
                    })
                }
        }
    }, [])

    useEffect(() => {
        if (readyToNavigate) {
            localStorage.setItem('questions', JSON.stringify(questions));
            tracking(Action.SAVE_QUESTIONS);
            navigate("/ChooseCover");
        }
    }, [readyToNavigate])

    useEffect(() => {
        if (scrollToError) {
            document.getElementsByClassName('validation-fail-lbl')[0].scrollIntoView({ behavior: 'smooth' });
            setScrollToError(false);
        }
    }, [scrollToError])

    const nextNavigation = () => {
        let formValid = true;

        var updatedQuestions = questions.map(question => {
            if (question.page === pageNo) {
                //if the question has already failed another validation then set the formValid to false
                if (question.validationFail) {
                    formValid = false;
                } else {
                    if (formValidation(question)) {
                        question.validationFail = false;
                    } else {
                        formValid = false;
                        question.validationFail = true;
                    }
                }
            }
            if (question.childInformation != null) {
                question.childInformation.map((childquestion: any) => {
                    if (childquestion.page === pageNo) {
                        //if the question has already failed another validation then set the formValid to false
                        if (childquestion.validationFail) {
                            formValid = false;
                        } else {
                            if (formValidation(childquestion)) {
                                childquestion.validationFail = false;
                            } else {
                                if ((question.questionSetQuestion.childQuestionRepeatMinimum > 0 && childquestion.index > 0) || question.questionSetQuestion.childQuestionRepeatMinimum === 0 || question.questionSetQuestion.childQuestionRepeatMinimum == null) {
                                    formValid = false;
                                    childquestion.validationFail = true;
                                }
                            }
                        }
                    }
                    return childquestion;
                });
            }
            return question;
        });
        if (IsWebReference("TL") && companyStatus === "limited") {
            var directorsValidation = relatedQuestionsValidation(updatedQuestions, manualDirectorsId, nonManualDirectorsId, "0", "You have selected 0 directors, please add at least 1 manual or non-manual director");

            updatedQuestions = directorsValidation.questions;

            if (formValid) {
                formValid = directorsValidation.valid;
            }
        }

        if (formValid) {
            setReadyToNavigate(true);
        } else {
            setQuestions([...updatedQuestions]);
            setScrollToError(true);
        }
    }

    const backNavigation = () => {
        var updatedQuestions = resetValidation(questions);

        localStorage.setItem('questions', JSON.stringify(updatedQuestions));

        navigate("/YourBusiness", {
            state: {
                questions: { questions },
                quotes: {}
            }
        });
    }

    const showConditionQuestions = (questionID: any, value: any) => {
        let newQuestions = showConditionalQuestionsInSet(questions, questionID, value);
        setQuestions(newQuestions);
    }

    const getIdOfFirstSectionQuestion = (sectionName: string) => {
        var sectionQuestions = questions.filter(x => x.sectionName === sectionName && x.questionSetQuestion.enabled && x.questionSetQuestion.visible && x.page === pageNo);

        // if a section exists with no enabled questions don't show it
        var returnQuestionID = 0;
        if (sectionQuestions.length > 0) {
            returnQuestionID = sectionQuestions[0].questionSetQuestion.questionID;
        }
        return returnQuestionID;
    }

    const setIndividualCustomerDetails = (question: any) => {
        if (question.questionSetQuestion.text.toLowerCase().includes("how many employees") && question.sectionName.toLowerCase() === "about your employees") {
            let employeeCountQuestions = questions.filter(x => x.questionSetQuestion.text.toLowerCase().includes("how many employees") && x.sectionName.toLowerCase() === "about your employees");
            let totalEmployeeCount = 0;
            employeeCountQuestions.forEach(employeeQuestion => {
                totalEmployeeCount = totalEmployeeCount + parseInt(employeeQuestion.answer);
            });
            let totalEmployeesQuestionID = 0;
            var updatedQuestions = questions.map(question => {
                if (question.questionSetQuestion.text.toLowerCase() === "total number of employees") {
                    question.answer = totalEmployeeCount.toString();
                    totalEmployeesQuestionID = question.questionSetQuestion.questionID;
                }
                return question;
            });
            setQuestions([...updatedQuestions]);
            enableQuestions(totalEmployeesQuestionID);
        }

    }

    const enableQuestions = (questionID: number) => {
        let newQuestions = enableQuestionsInSet(questions, questionID);
        setQuestions(newQuestions);
    }

    const resetRelatedQuestionsValidationOnAnswerChange = (questionID: number, answer: string) => {
        if (IsWebReference("TL") && companyStatus === "limited") {
            if ((questionID === manualDirectorsId || questionID === nonManualDirectorsId) && answer !== "0") {
                let newQuestions = resetRelatedQuestionsValidation(questions, manualDirectorsId, nonManualDirectorsId);
                setQuestions([...newQuestions]);
            }
        }
    }

    const showConditionalChildren = (parentQuestionID: number, value: any, firstChildQuestionID: number, firstChildIndex: number, secondChildQuestionID?: number, secondChildIndex?: number) => {
        if (secondChildQuestionID != null && secondChildIndex != null) {
            let newQuestions = showConditionalChildrenChildren(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(secondChildQuestionID.toString()), parseInt(firstChildIndex.toString()), parseInt(secondChildIndex.toString()), value);
            setQuestions(newQuestions);
        } else {
            let newQuestions = showConditionalChildrenQuestions(questions, parseInt(parentQuestionID.toString()), parseInt(firstChildQuestionID.toString()), parseInt(firstChildIndex.toString()), value);
            setQuestions(newQuestions);
        }
    }

    const resetCoverValidation = () => { }

    return (
        <>
            <div className="form-container">
                <FormTitle title="Employee details" />
                {questions.map((question, index) => {

                    return (<div key={index}>
                        {question.questionSetQuestion.questionID === getIdOfFirstSectionQuestion(question.sectionName) && question.page === pageNo && question.questionSetQuestion.visible &&
                            <div className="section-header" key={question.questionSetQuestion.questionID + "_" + question.questionSetQuestion.sectionID}>{question.sectionName}</div>
                        }
                        <Question question={question} key={question.questionSetQuestion.questionID} showConditionQuestions={showConditionQuestions} enableQuestions={enableQuestions} resetRelatedQuestionsValidationOnAnswerChange={resetRelatedQuestionsValidationOnAnswerChange} page={pageNo} setIndividualCustomerDetails={setIndividualCustomerDetails} showConditionalChildren={showConditionalChildren} questionIdPosition={question.questionSetQuestion.questionID + "-" + question.index} resetCoverValidation={resetCoverValidation} />
                    </div>)
                }
                )}
            </div>

            <div className="btn-container">
                <button className="btn back" onClick={() => backNavigation()}>Back: Your business</button>
                <button className="btn primary" onClick={() => nextNavigation()}>Next: Cover details</button>
            </div>
            <BackToTop />
        </>
    )
}